//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import {
		api_SellItem
	} from '@/api'
	import Swiper from 'swiper'
	export default {
		name: 'wh_swiper',
		props: {
			renew: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				swiper: null,
				show: false,
				activeIndex:null
			}
		},
		updated() {
			if (this.swiper == null) {
				this.SwiperInit()
			}
		},
		methods: {
			//初始化
			SwiperInit() {
				let that = this
				this.swiper = new Swiper('.swiper-container', {
							//循环模式
							loop: false,
							// 如果需要前进后退按钮
							navigation: {
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev',
							},
							pagination: {
							    el: '.swiper-pagination',
							    type: 'fraction',
							  },
							on: {
								slideChangeTransitionEnd() {
									if(that.activeIndex !== null){
										that.swiper.removeSlide(that.activeIndex)
										that.activeIndex = null
										that.set_official_loading(false)
									}
								}
							}
						})
					},
					//展示
					open() {
						this.show = true
					},
					//兑换
					to_sell() {
						this.set_official_loading(true)
						this.$nextTick(() => {
							let id = document.getElementsByClassName('swiper-slide-active')[0].attributes.mSerial.value

							console.log(id);
							api_SellItem({ lstmSerial: [id] }).then(res => {
								if (res.data.success) {
									this.handle(id)
									this.$toast.success( res.data.msg)
									this.set_scrape()
								} else {
									this.set_official_loading(false)
									this.$toast.error( res.data.msg)
								}
							}).catch(err => this.set_official_loading(false))
						})
						
					},

					//兑换处理
					handle(id) {
						//先删除缓存
						let arr = JSON.parse(sessionStorage.getItem('renew'))
						let list = arr.filter(item => item != id)
						sessionStorage.setItem('renew',JSON.stringify(list))
						//swiper操作
						this.$nextTick(() => {
							let swiper_length = document.getElementsByClassName('swiper-slide').length - 1
							if(swiper_length > 0){
								let index = this.swiper.activeIndex
								this.activeIndex = this.swiper.activeIndex
								if (index == swiper_length) {
									this.swiper.slidePrev() //滑动到上一页
								} else {
									this.swiper.slideNext() //滑动到下一页
								}
							}else{
								//最后一个
								this.close()
							}
						})
					},
					
					// 全删(关闭)
					close(){
						sessionStorage.setItem('renew',JSON.stringify([]))
						this.set_scrape()
						this.show = false
						this.$emit('close')
					}
			},
			watch: {
				renew(v) {
					if (v.length > 0) {
						this.open()
					}
				}
			}
		}
